// Convertit une URL vidéo "grand public" (lien YouTube/Vimeo partagé) en URL
// d'intégration (<iframe>) — sinon on considère qu'il s'agit d'un fichier
// vidéo direct (mp4/webm...) à lire avec une balise <video>. Purement
// cosmétique côté frontend : la validation de sécurité (schéma autorisé,
// longueur) est déjà faite côté serveur (theme_service._valid_link_url).
export function toEmbedUrl(url, { autoplay = false, loop = false } = {}) {
  if (!url) return null;
  const params = [];
  if (autoplay) params.push("autoplay=1", "mute=1");

  const youtubeWatch = url.match(/(?:youtube\.com\/watch\?v=|youtube\.com\/shorts\/)([\w-]{6,})/);
  const youtubeShort = url.match(/youtu\.be\/([\w-]{6,})/);
  const youtubeId = (youtubeWatch || youtubeShort)?.[1];
  if (youtubeId) {
    if (loop) params.push(`loop=1`, `playlist=${youtubeId}`);
    return { kind: "iframe", src: `https://www.youtube.com/embed/${youtubeId}?${params.join("&")}` };
  }

  const vimeoId = url.match(/vimeo\.com\/(\d+)/)?.[1];
  if (vimeoId) {
    if (loop) params.push("loop=1");
    return { kind: "iframe", src: `https://player.vimeo.com/video/${vimeoId}?${params.join("&")}` };
  }

  return { kind: "video", src: url };
}
